import Logo from "@/assets/logo.svg?react";
import { useWhitelabel } from "@/hooks/useWhitelabel";

interface AuthContainerProps {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  customIcon?: React.ReactNode;
  description: string;
  footer?: React.ReactNode;
  title: string;
}

export function AuthContainer({
  children,
  className,
  containerClassName,
  customIcon,
  description,
  footer,
  title,
}: AuthContainerProps) {
  const { config, isWhitelabel, loading } = useWhitelabel();

  const logoElement = isWhitelabel ? (
    config?.logoUrl ? (
      <img
        alt={config.partnerName}
        className="h-12 object-contain"
        src={config.logoUrl}
      />
    ) : null
  ) : (
    customIcon || (
      <a href="https://nlc.com" rel="noopener noreferrer" target="_blank">
        <Logo className="size-4xl" />
      </a>
    )
  );

  if (loading) {
    return null;
  }

  return (
    <div
      className={`grid h-screen place-items-center bg-bg-secondary ${containerClassName ?? ""}`}
    >
      <div className="flex flex-col items-center gap-4xl">
        <div
          className={`flex w-[384px] flex-col gap-3xl rounded-md bg-bg-primary p-3xl ${className}`}
        >
          <div className="flex flex-col gap-5xl">
            <div className="flex flex-col items-center gap-2xl">
              {logoElement}
              <h1 className="text-display-sm font-semibold text-text-primary text-center">
                {title}
              </h1>
              <span className="text-center text-md text-text-tertiary">
                {description}
              </span>
            </div>
            {children}
          </div>
        </div>
        {footer && <div className="flex gap-3xl">{footer}</div>}
      </div>
    </div>
  );
}
